module.exports = __webpack_public_path__ + "img/close.87171139.svg";